module.exports = __webpack_public_path__ + "img/notifications-alert-circle.5cfbbb7f.svg";